module.exports = __webpack_public_path__ + "img/35_45.c5102ef7.png";